const HeroSection = {
  hero_title_part1: "Kolay ve Güvenli",
  hero_title_part2: "Kargo Hizmeti",
  hero_text: "Kargonuzu evinizden çıkmadan gönderin",
  hero_btn: "Kargo şirketleri",
  hero_card_title: "Kargo rotasını seçin",
  hero_card_section_title1: "Nereden",
  hero_card_section_text1: "Kargo nereden gönderilecek?",
  hero_card_section_title2: "Nereye",
  hero_card_section_text2: "Kargo nereye gönderilecek?",
  hero_card_section_title3: "Kargo Ağırlığı",
  hero_card_section_text3: "Ortalama ağırlığı seçiniz",
  hero_card_btn: "Sonuçları göster",
  hero_presentation_title1: "Bizim avantajlarımız",
  hero_presentation_text1: "En gelişmiş kargo hizmeti",
  hero_presentation_content1_title1: "Evinizden alınır",
  hero_presentation_content1_text1:
    "Artık kargo göndermek için evinizden çıkmanıza gerek yok",
  hero_presentation_content1_title2: "Ucuz ve güvenli gönderi",
  hero_presentation_content1_text2:
    "Kargolarınızı 1$* başlayan fiyatlarla güvenli bir şekilde gönderin",
  hero_presentation_content1_title3: "Kargo takibi",
  hero_presentation_content1_text3:
    "Kargonuzun nerede olduğunu takip edebilirsiniz",

  hero_presentation_title2: "Kargo nasıl gönderilir?",
  hero_presentation_text2: "Kargo gönderim detayları",
  hero_presentation_content2_title1: "Paketleme",
  hero_presentation_content2_text1:
    "Gönderinizi ölçün ve bir kargo şirketi seçin",
  hero_presentation_content2_title2: "Hazırlama",
  hero_presentation_content2_text2:
    "Kurye kargonuzu aynı gün adresinizden teslim alır, paketler ve sevkiyata hazır hale getirir.",
  hero_presentation_content2_title3: "Gönderi ve takip",
  hero_presentation_content2_text3:
    "Kargonuz yola çıktığında, size verilen takip numarası ile takip edebilirsiniz",
};

const HomeFAQ = {
  home_faq_title: "Sıkça sorulan sorular",
  home_faq_tab1: "Genel",
  home_faq_tab2: "Destek",
  home_faq_tab3: "Kargo",
  home_faq_tab4: "Sorular",
  home_faq_tab1_question1: "Kargo nasıl gönderilir?",
  home_faq_tab1_question2: "Kargomu nasıl takip edebilirim?",
  home_faq_tab1_question3: "Kaç günde teslim edilir?",
  home_faq_tab1_question4: "Nelere dikkat etmeliyim?",
  home_faq_tab1_question5: "Ödeme nasıl yapılır?",
};

const Blog = {
  blog_title: "Blog",
  blog_text: "Altyazı",
  blog_card_delivery: "Gönderim",
  blog_card_coupon: "Kupon",
  blog_card_discount: "İndirim",
};

const FormControls = {
  smart_sorting: "Akıllı sıralama",
  by_rating: "Puana göre",
  by_price: "Fiyata göre",
  by_delivery_speed: "Teslimat hızına göre",
  oldest_comments: "En eski yorumlar",
  newest_comments: "En yeni yorumlar",
  all_comments: "Tüm yorumlar",
};

const ProductCard = {
  day: "Gün",
  fast_delivery: "Hızlı ve kaliteli",
  highlights: "Öne çıkanlar",
  new_companies: "Yeni şirketler",
  product_card_delivery: "Teslimat",
  product_card_kg_price: "Kg ücreti",
  product_card_minimum: "Minimum gönderi",
};

export const Header = {
  header_search: "Ara",
  header_btn: "Kargo takip",
  current_language: "Türkçe",
};

export const Footer = {
  footer_copyright: "Tüm hakları saklıdır © 2021",
  footer_link_title1: "Şirket",
  footer_link_title2: "Genel",
  footer_link_about: "Hakkımızda",
  footer_link_services: "Hizmetler",
  footer_link_blog: "Blog",
  footer_link_policy: "Gizlilik politikası",
  footer_link_companies: "Şirketler",
  footer_link_faq: "S.S.S",
  footer_subscription_title: "Bize Katılın",
  footer_subscription_input: "Eposta yazınız",
};

export const SiteNav = {
  adressess: "Adreslerim",
  cargos: "Kargolarım",
  settings: "Ayarlar",
  track_cargo: "Kargo takip",
  logout: "Çıkış",
  search: "Ara",
  account: "Hesabım",
};

const Info = {
  total_founded: "Toplam bulunan",
  cargo_companies: "Kargo şirketleri",
  company: "Şirket",
  comment: "yorum",
  membership_date: "Üyelik tarihi",
  cargo_price: "Kargo ücreti",
  starting_price: "başlayan fiyatlar",
  about: "hakkında",
  minimum_shipment_abbreviated: "Min. gönderi",
  tooltip_price_may_vary: "Gönderilen ürüne göre fiyat farkı olabilir",
};

const Comment = {
  company_response: "Şirket cevabı",
  comments_loading: "Yorumlar yükleniyor",
  add_comment: "Yorum ekle",
  comment_question: "Bu şirketten hizmet aldınız mı? Fikrinizi yazınız",
  share_your_opinion: "Fikrinizi paylaşın",
  share: "Paylaş",
};

const Actions = {
  call_courier: "Kurye çağır",
  report_company: "Şirketi şikayet et",
  accept_and_call_courier: "Onayla ve kurye çağır",
  go_to_homepage: "Ana sayfaya git",
  action_track_cargo: "Kargoyu takip et",
  action_update_info: "Bilgileri güncelle",
  action_cancel: "İptal et",
  action_add_new_address: "Yeni adres ekle",
  action_change: "Değiştir",
  action_change_password: "Şifreyi değiştir",
  action_apply: "Uygula",
  action_save_address: "Adresi kaydet",
  action_show_results: "Sonuçları göster",
  action_comment: "Yorum yaz",
  action_go_to_profile: "Profile git",
  action_show_all: "Hepsini göster",
};

const Paths = {
  home_page: "Ana sayfa",
  all_companies: "Tüm şirketler",
  path_call_courier: "Kurye çağırma",
};

const Form = {
  form_calling_courier_and_prica_calculator: "Kurye çağırma ve fiyat hesaplama",
  form_shipper: "Gönderici",
  form_name_surname: "Ad Soyad",
  form_tel: "Telefon numarası",
  form_shipping_address: "Kargonun alınacak adresi",
  form_address_details: "Mahalle/Sokak/Daire",
  form_recipient: "Alıcı",
  form_warn_empty: "Bu alan boş bırakılamaz",
  form_warn_email_invalid_format: "Lütfen geçerli bir email adresi giriniz",
  form_warn_password_unmatched: "Parolalar eşleşmiyor",
  form_warn_tel_invalid: "Lütfen geçerli bir numara giriniz",
  form_delivery_address: "Kargonun teslimat adresi",
  form_what_to_ship: "Ne göndereceksiniz?",
  form_what_to_ship_desc:
    "Göndereceğiniz eşyaya göre fiyat farkı olabilmektedir",
  form_cargo_weight: "Kargonuzun ağırlığı",
  form_box_weight: "Kutu ağırlığı",
  form_cargo_receival_date: "Kargonuzun alınacak tarihi",
  form_date_select_today: "Bugün",
  form_date_select_tomorrow: "Yarın",
  form_date_custom: "Tarih ekle",
  form_note: "Not",
  form_note_optional: "İsteğe göre",
  form_privacy_policy: "Şartları okudum ve onaylıyorum",
  form_country: "İl",
  form_district: "İlçe",
  form_error: "Hata",
  form_country_land: "Ülke",
  form_do_you_have_coupon: "Kupon kodu var mı?",
  form_enter_coupon_code: "Kupon kodu girin",
};

const TotalCard = {
  total_card_title: "Toplam",
  total_card_shipper: "Gönderici",
  total_card_recipient: "Alıcı",
  total_card_cargo_route: "Kargo rotası",
  total_shipment_weight: "Gönderi ağırlığı",
  total_price_title: "Fiyat bilgileri",
  total_cargo_price: "Kargo ücreti",
  total_service_price: "Servis ücreti",
  total_free: "Ücretsiz",
  total_sum: "Genel toplam",
  total_coupon_discount: "Kupon indirimi",
};

const Modal = {
  member_login: "Üye girişi",
  modal_new_membership: "Yeni  üyelik",
  password_proccess: "Şifre işlemi",
  modal_tel: "Telefon numaranız",
  forgot_password: "Şifremi unuttum",
  login: "Giriş yap",
  password: "Şifre",
  login_via_social: "Sosyal hesap ile giriş yap",
  no_account_question: "Hesabınız yok mu?",
  have_account_question: "Hesabınız var mı?",
  modal_sign_up: "Üye ol",
  remember_me: "Beni hatırla",
  password_again: "Şifre tekrarı",
  renew_password: "Parola yenile",
  sms_verification: "SMS doğrulama",
  accept_and_continue: "Onayla ve devam et",
  send_code_again: "Kodu tekrar gönder",
  enter_4_digit_number: "numaraya gönderilen 4 haneli kodu girin",
  modal_register: "Kaydol",
  modal_enter_tel_text:
    "Kayıt sırasında kullandığınız telefon numaranızı yazınız",
  modal_cargo_track: "Kargo takibi",
  modal_enter_track_number: "Takip numaranızı yazınız",
  track_no: "Takip no",
};

const InfoPages = {
  info_thanks: "Teşekkürler!",
  info_no_order_created: "numaralı siparişiniz oluşturuldu.",
  info_shipping_process: "Kargo sürecini",
  info_profile: "Profil",
  info_from_page_follow: "sayfanızdan takip edebilirsiniz",
  info_track_number: "Takip numaranız",
};

const ProfilePage = {
  profile_notifications: "Bildirimler",
  profile_enter_track_number: "Takip numarası girin",
  profile_cargo_status_title: "Kargo statüsü",
  profile_cargo_situation_onway: "Kargonuz yolda",
  profile_cargo_situation_delivered: "Teslim edildi",
  profile_track_no: "Takip no",
  profile_cargo_from: "Çıkış yeri",
  profile_cargo_to: "Varış yeri",
  profile_cargo_date: "Kargo tarihi",
  profile_price: "Fiyat",
  profile_all_cargos: "Tüm kargolar",
  profile_on_the_way: "Yolda olan",
  profile_completed: "Tamamlanan",
  profile_all: "Hepsi",
  profile_cargo_id: "Kargo ID",
};

const Settings = {
  settings_support_text:
    "Eposta adresi değiştirmek için bizimle iletişime geçiniz.",
  settings_title: "Ayarlar",
  settings_write_message: "Mesaj yaz",
  settings_current_password: "Mevcut şifreniz",
  settings_new_password: "Yeni şifre",
  settings_new_password_again: "Yeni şifre tekrarı",
};

const MyAdresses = {
  my_addresses_title: "Adreslerim",
  address: "Adres",
};

const AddAddress = {
  add_address_name: "Adres açıklaması (Örn Evim, İş)",
  add_address_city: "Şehir",
  add_address_district: "Bölge",
  add_address_details: "Mahalle/Sokak/Daire",
};

const NotFound = {
  not_found_title: "Sayfa bulunamadı",
  not_found_text: "Aradığınız sayfa silinmiş veya yanlış adres olabilir",
};

const CargoTrack = {
  cargo_track_title: "Kargo hareketi",
  cargo_track_cargo_accepted: "Kargonuz kabul edildi",
  cargo_track_shipped: "Hedef ülkeye gönderildi",
  cargo_track_arrived: "Hedef ülkeye ulaştı",
  cargo_track_at_branch: "Kargonuz şubede",
  cargo_track_out_for_distribution: "Dağıtıma çıktı",
  cargo_track_delivered: "Teslim edildi",
  cargo_track_last_update: "Son değişiklik",
  cargo_track_no: "Kargo takip numarası",
  cargo_track_tel: "Telefon",
  cargo_track_sum: "Toplam ücret",
};

const FAQ = {
  faq_search_title: "Sık sorulanlar",
  faq_search_text: "Sorunuzu arayarak çözüme daha hızlı ulaşabilirsiniz",
  faq_search_placeholder: "Soru arayın",
  faq_title: "Sıkça sorulan sorular",
  faq_text_part1: "Aradığınız cevabı bulamadıysanız",
  faq_support_link: "Destek merkezimize",
  faq_text_part2: "yazabilirsiniz",
  faq_tab1: "Genel",
  faq_tab2: "Kargo",
  faq_tab3: "Sorular",
};

const CompanyCard = {
  company_card_free_packaging: "Ücretsiz paketleme",
};

const Toast = {
  toast_success_title: "Başarılı",
  toast_error_title: "Hata",
  toast_warn_title: "Dikkat",
  toast_info_title: "Bildirim",
  toast_success_text: "İşlem başarılı bir şekilde gerçekleştirildi.",
  toast_error_text: "Bir hata oluştu.",
  toast_warn_text: "Bildirim yazısı",
  toast_info_text: "Bildirim yazısı",
};

const Extra = {
  blog_similar_blogs: "Benzer bloglar",
};

export const Shared = {
  ...Footer,
  ...SiteNav,
  ...FormControls,
  ...ProductCard,
  ...Info,
  ...Paths,
  ...Comment,
  ...Actions,
  ...TotalCard,
  ...Form,
  ...Modal,
  ...InfoPages,
  ...ProfilePage,
  ...Settings,
  ...MyAdresses,
  ...AddAddress,
  ...NotFound,
  ...CargoTrack,
  ...FAQ,
  ...CompanyCard,
  ...Toast,
  ...Extra,
};

export const HomePage = {
  ...HeroSection,
  ...HomeFAQ,
  ...Blog,
};
